import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledTextField, Fieldset } from '@components';
import { useStore } from '@stores';

export const ZipCode = observer(() => {
  const { t } = useTranslation('subModules/zipCode');
  const { utilityStore } = useStore();

  const { setValue } = useFormContext();

  useEffect(() => {
    if (utilityStore.state) {
      setValue('state', utilityStore.state);
    }
  }, [utilityStore.state, setValue]);

  return (
    <Fieldset label={t('label')} data-tf-sensitive="true" required>
      <ControlledTextField
        fieldName="zipCode"
        placeholder="00000"
        data-testid="zipCodeSubModule"
        label={t('placeholder')}
        inputMode="numeric"
      />
    </Fieldset>
  );
});
